<template>
  <div class="motorway" :class="{ 'motorway--last': isLast }">
    <p class="motorway__header" v-html="header"></p>
    <p class="motorway__subheader" v-html="subheader"></p>
    <div class="motorway__container">
      <div class="motorway__logo">
        <img class="motorway__logo-image" src="~@/assets/images/motorway-logo.png" alt="motorway-logo" />
      </div>
      <div class="motorway__benefits-container">
        <p class="motorway__list-header" v-html="motorwayBenefitsHeader"></p>
        <ul class="motorway__list">
          <li class="motorway__list-item" v-for="item in items" :key="item.id">
            <img class="motorway__list-check" src="~@/assets/images/check-green.png" />
            <span>{{ item.text }}</span>
          </li>
        </ul>
        <a class="tla-btn tla-btn--info motorway__link" :href="replaceLinkWithRegistrationMark(link)" target="_blank" type="button" v-html="buttonText" @click="submitExtraData()"></a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import ExtraData from '@/models/ExtraData';
import {
  Component, Prop, Vue
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import ListItem from '../../viewmodels/ListItem';

const EnquiryModule = namespace('enquiryModule');
const PostEnquiryModule = namespace('postEnquiryModule');

@Component
export default class MotorwayComponent extends Vue {
  @EnquiryModule.Getter public extraData;

  @PostEnquiryModule.Action public submitEnquiryExtraData;

  @Prop({
    default: () => [
      'Find your best offer from over 3,000+ verified dealers',
      'Sell your car for free in as little as 24 hours',
      'Get free home collection and fast payment',
      'Get up to £1,000 more']
  })
  public benefits!: string[];

  @Prop({ default: 'Need to sell your car?' })
  public header!: string;

  @Prop({ default: '<strong>Motorway</strong> will find the dealer who’ll pay the most for your car, with no haggling or hassle.' })
  public subheader!: string;

  @Prop({ default: '<strong>Benefits of using Motorway</strong>' })
  public motorwayBenefitsHeader!: string;

  @Prop({ default: 'Sell your car' })
  public buttonText!: string;

  @Prop({ default: 'https://motorway.co.uk/[vrm]/?utm_source=tla&utm_medium=affiliate&utm_campaign=askaprice' })
  public link!: string;

  @Prop({ default: false })
  public isLast!: boolean;

  private items: ListItem[] = [];

  public replaceLinkWithRegistrationMark(link: string): string {
    let vrm;

    if (link.includes('[vrm]')) {
      vrm = this.extraData.find((x) => x.keyName === 'PartExchangeRegistration');

      if (vrm) {
        const formattedVRM = vrm.keyValue.replace(' ', '');

        link = link.replace('[vrm]', formattedVRM);

        return link;
      }
    }

    return link;
  }

  public submitExtraData() {
    const data: ExtraData[] = [
      {
        keyName: 'motorwayAdClick',
        keyValue: 'true'
      }
    ];
    this.submitEnquiryExtraData(data);
  }

  public created() {
    this.items = this.benefits.map((a: any, i: number) => new ListItem(i, a));
    const data: ExtraData[] = [
      {
        keyName: 'motorwayAdLoad',
        keyValue: 'true'
      }
    ];
    this.submitEnquiryExtraData(data);
  }
}
</script>
